import ProjectScreen from './index';
import DetailScreen from './detail';
import CreateScreen from './create';
import UpdateScreen from './update';

const routes = [
  {
    path: '/master/project',
    component: ProjectScreen,
  },
  {
    path: '/master/project/create',
    component: CreateScreen,
  },
  {
    path: '/master/project/:id',
    component: DetailScreen,
  },
  {
    path: '/master/project/:id/update',
    component: UpdateScreen,
  },
];

export default routes;
